module.exports = __webpack_public_path__ + "img/clothes_crocodile_top@2x.c799f877.png";